import React from 'react';

import './AdminCardOrderField.css';

const AdminCardOrderField = ({ type = 'order', children }) => {
  let displayValue = children;

  if (type === 'date') {
    displayValue = new Date(children).toLocaleDateString('en-CA', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  return (
    <div
      className={`admin-item-order-container ${
        type === 'date' ? 'date-mode' : 'order-mode'
      }`}
    >
      {displayValue}
    </div>
  );
};

export default AdminCardOrderField;
